import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle", "icon"]

  connect() {
    // Start collapsed
    this.collapsed = true
  }

  toggle() {
    this.collapsed = !this.collapsed

    if (this.collapsed) {
      this.contentTarget.classList.add("hidden")
      this.toggleTarget.setAttribute("aria-expanded", "false")
      this.iconTarget.classList.remove("rotate-180")
    } else {
      this.contentTarget.classList.remove("hidden")
      this.toggleTarget.setAttribute("aria-expanded", "true")
      this.iconTarget.classList.add("rotate-180")
    }
  }
}
